import { useEffect, useState } from "react";

export function useDeviceVariant() {
  const [variant, setVariant] = useState(() => {
    if (typeof window === "undefined") return "desktop";

    // "mobile" = small-ish AND touch device
    const mq = window.matchMedia("(max-width: 1024px) and (pointer: coarse)");
    return mq.matches ? "mobile" : "desktop";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mq = window.matchMedia("(max-width: 1024px) and (pointer: coarse)");

    const listener = (e) => {
      setVariant(e.matches ? "mobile" : "desktop");
    };

    // for Safari / older browsers, use addListener/removeListener if needed
    mq.addEventListener?.("change", listener);
    mq.addListener?.(listener);

    return () => {
      mq.removeEventListener?.("change", listener);
      mq.removeListener?.(listener);
    };
  }, []);

  return variant;
}
